module.exports = __webpack_public_path__ + "static/metrics-hero-1-91e2dff01ce2782bcca827a58baf9c68.png";